/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> SEARCH
   ==================================================================== */

const search = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'search',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    toggleSearch(e) {
      e.preventDefault();
      this.panel.classList.toggle('is-open');
      // Toggle button Text
      console.log(this.btn.innerText);
      if (this.btn.innerText === 'SEARCH') {
        this.btn.innerText = 'CLOSE';
      } else {
        this.btn.innerText = 'SEARCH';
      }
    },
    logResized() {
      console.log(`${this.name}: Resized`);
    },
    logDisabled() {
      console.log(`${this.name}: Disabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */
      /**
       * Expose the behaviour object for debugging
       */
      // console.log(this.name + ':', this);

      this.btn = document.querySelector('[data-search-btn]');

      this.panel = this.node;
    },
    enabled() {
      /**
       * The behaviour has been enabled; functions, variable overwrites
       * etc. can be called here
       * All functions, variables etc. are accessible through `this
       */
      // this.logEnabled();

      this.btn.addEventListener('click', this.toggleSearch);
    },
  },
);

export default search;
